import { Modal } from "antd"

const tint = (id) => (id % 4) + 1

// antd Modal provides the shell + behaviour (Esc, scroll-lock, focus-trap,
// animations); the journal two-pane content and styling are ours.
const BookModal = ({ book, onClose }) => {
  const csrf = document.querySelector('meta[name="csrf-token"]')?.content

  return (
    <Modal
      open={Boolean(book)}
      onCancel={onClose}
      footer={null}
      closable={false}
      centered
      width={860}
      className="book-modal"
      styles={{
        content: { padding: 0, overflow: "hidden", borderRadius: 10, background: "#f6efdd" },
        body: { padding: 0 },
        mask: { background: "rgba(60, 44, 30, 0.34)", backdropFilter: "blur(6px) saturate(108%)" },
      }}
    >
      {book && (
        <div className="modal__sheet">
          <div className="modal__visual">
            <div className="modal__polaroid">
              {book.cover_url ? (
                <img key={book.id} className="modal__cover" src={book.cover_large_url || book.cover_url} alt={book.title} decoding="async" />
              ) : (
                <div className={`entry__photo entry__photo--blank t${tint(book.id)}`}>
                  <span className="entry__blank-title">{book.title}</span>
                  <span className="entry__blank-author">{book.author}</span>
                </div>
              )}
            </div>
          </div>

          <div className="modal__body">
            <button type="button" className="modal__close" onClick={onClose} aria-label="Закрити">
              ×
            </button>

            <h2 className="modal__title">{book.title}</h2>
            <p className="modal__author">— {book.author}</p>
            {book.genre && <span className="modal__genre">#{book.genre}</span>}

            <svg className="modal__rule" viewBox="0 0 220 12" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <path d="M4 7 C 40 1, 60 11, 96 6 S 160 1, 216 6" />
            </svg>

            <dl className="modal__meta">
              <div>
                <dt>Додано у щоденник</dt>
                <dd>{book.added_on}</dd>
              </div>
            </dl>

            <div className="modal__actions">
              <a className="btn" href={`/books/${book.id}/edit`}>
                Редагувати
              </a>
              <form
                action={`/books/${book.id}`}
                method="post"
                onSubmit={(event) => !confirm("Прибрати цю книжку зі щоденника?") && event.preventDefault()}
              >
                <input type="hidden" name="_method" value="delete" />
                <input type="hidden" name="authenticity_token" value={csrf} />
                <button type="submit" className="btn btn-ghost">
                  Видалити
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </Modal>
  )
}

export default BookModal
